import LegalPageLayout from "../common/LegalPageLayout";

// Content lives in locales/{es,en,de}/translation.json under "legal_pages.privacy_policy".
// See LegalPageLayout.js for the expected shape and how to edit/extend it.
const PrivacyPolicy = () => <LegalPageLayout translationKey="legal_pages.privacy_policy" />;

export default PrivacyPolicy;
